import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventsRoutingModule } from './events-routing.module';
import { EventsComponent } from './events.component'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CalendarModule, DateAdapter} from 'angular-calendar';
import { SharedModule } from '../shared/shared.module';
import { ChildHeaderModule } from '../child-header/child-header.module';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { BreadcrumbModule } from '../breadcrumb/breadcumb.module';



@NgModule({
  imports: [
    CommonModule, 
    EventsRoutingModule, 
    NgbModule,
    SharedModule,
    ChildHeaderModule,
    BreadcrumbModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    })],
  declarations: [
    EventsComponent,
  ],
  providers: [
  ]
})
export class EventsModule {}